<template>
<div>
	<FormRow>
  		<input type="checkbox" id="inHonorOf" name="inHonorOf" v-model="inHonorOf"/> 
  		<FormLabel for="inHonorOf">Dedicate your donation</FormLabel>
	</FormRow>
	<div  v-if="inHonorOf" class="honor-container">
		<FormRow inline>	
			<div style="max-width: 300px">		
				<label>
				In honor of			
				</label>
				<select id="honoree" name="honoree" @change="setValue('honoreeName', $event.target.value)">   
					<option value="ZviSnad">Zvi Sand</option>
					<option value="Zula">fo the Zula</option>
					<option value="Ouistal">for OU Israel</option>
				</select>
			</div>
		</FormRow>
		<FormRow inline>
			<FormCol field="dedicationMessage" />
		</FormRow>
	</div>
</div>
</template>
<script lang="ts">
import { defineComponent, type PropType, ref, watch } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  props: {
    recipent: {
      type: Boolean,
      default: true
    }
  },	
  setup() {
	
	const { form, setValue } = usePaymentForm()
	const inHonorOf = false

	  return {
		  inHonorOf,
		  setValue
	  }
  }
})
</script>
<style scoped lang="scss">
input[type="checkbox"] {
	margin-right: 7px;
}
.honor-container {
	padding-top: 20px;
	border-top: 1px solid #ddd;
	margin-top: 20px;
}
.flex {
	display: flex;
	align-items: center;
}
.honor-type {
	max-width: 150px;
	min-width: 150px;
	margin-right: 7px;
}
.edit-recipient {
	color: $color-blue;
	font-size: 13px;
	cursor: pointer;
	&:hover {
		text-decoration: underline;
	}

}
label {
	font-size: 14px;
    color: #222;
    padding-top: 3px;
    padding-bottom: 3px;
    display: block;
}
</style>